import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  IconButton,
  InputBase,
  Pagination,
  Menu,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ExportDropdown from "../../../components/ExportDropdown";
import StatusDropdown from "../../../components/StatusDropdown";
import { showUnderDevelopment } from "../../../components/alerts";
import AttendanceDetailsDrawer from "../Attendance/MonthlySummary/DetailsDrawer";
import { useTranslation } from "react-i18next";
import { BASE_URL } from "../../../components/BaseUrl";
import { decryptToken } from "../../../Utlis/Encryption";
import TruncatedCell from "../../../components/TruncatedCell";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import emptyscreen from "../../../assets/Dashboard/emptyscreen.svg";
import CustomText, { textStyles } from "../../../components/CustomText";
import {useLocation,useNavigate} from "react-router-dom";
import back from "../../../assets/back.svg";
import mapicon from "../../../assets/Dashboard/mapicon.svg";
import { pdf } from "@react-pdf/renderer";
import { convertUTCToLocalDateTime } from "../../../components/dateTimeUtils";
import { getDayClassificationStatus } from "../Attendance/MonthlySummary/monthlyAttendanceUtils";
const DashboardPunches = () => {
  const { t } = useTranslation();
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  // Drawer + menu state
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
const location = useLocation();
  const navigate = useNavigate();
  const fromDashboard = location.state?.fromDashboard;
  const rawEncryptedToken = localStorage.getItem("token");
  const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;
  const [selectedMonth, setSelectedMonth] = useState(dayjs());
  const normalizeStatus = (status) => {
    if (!status) return status;
    const normalized = String(status).trim().toLowerCase().replace(/\s+/g, "_");
    return ["has_issue", "has_issues"].includes(normalized) ? "invalidPunch" : status;
  };

  const formatPunchPreview = (times = []) => {
    const validTimes = times.filter((time) => time && time !== "-");
    if (validTimes.length === 0) return "-";
    if (validTimes.length === 1) return validTimes[0];
    return `${validTimes[0]}\n...\n${validTimes[validTimes.length - 1]}`;
  };

  
  const [allRows, setAllRows] = useState([]);
  const [monthlyApiData, setMonthlyApiData] = useState(null);

useEffect(() => {
  const fetchData = async () => {
    setLoading(true);
    try {
      const monthParam = selectedMonth.format("YYYY-MM");
      const res = await fetch(
        `${BASE_URL}/attendance/monthly?month=${monthParam}&search=${searchQuery}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const data = await res.json();
      console.log("monthly data is", data);

      if (!data.error) {
        setMonthlyApiData(data.data || null);
     const formatted = (data.data.records || []).map((item, idx) => {
  const formatLocalTime = (utcString) => {
    const formattedValue = convertUTCToLocalDateTime(utcString, {
      formatOptions: {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      },
    });
    return formattedValue === "—" ? "-" : formattedValue;
  };

  const getPunchTimesByType = (actionType) =>
    (item.punches || [])
      .filter((punch) => punch.action_type === actionType && punch.occurred_at)
      .sort((a, b) => new Date(a.occurred_at) - new Date(b.occurred_at))
      .map((punch) => formatLocalTime(punch.occurred_at));

  const checkInTimes = getPunchTimesByType("CLOCK_IN");
  const checkOutTimes = getPunchTimesByType("CLOCK_OUT");
  const breakStartTimes = getPunchTimesByType("BREAK_START");
  const breakEndTimes = getPunchTimesByType("BREAK_END");
  const issueCount = Number(
    item?.total_punch_issue_count ?? item?.issues?.total_punch_issue_count ?? 0
  );
  const classificationStatus =
    getDayClassificationStatus(item) || normalizeStatus(item.status);

  return {
    id: idx + 1,
    date: new Date(item.date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }),
    checkIn: formatPunchPreview(
      checkInTimes.length ? checkInTimes : [formatLocalTime(item.first_check_in)]
    ),
    checkOut: formatPunchPreview(
      checkOutTimes.length ? checkOutTimes : [formatLocalTime(item.last_check_out)]
    ),
    startBreak: formatPunchPreview(breakStartTimes),
    endBreak: formatPunchPreview(breakEndTimes),
    location:
      item.punches?.[0]?.location?.location_text ||
      (item.punches?.[0]?.location?.gps_latitude && item.punches?.[0]?.location?.gps_longitude
        ? `${item.punches[0].location.gps_latitude}, ${item.punches[0].location.gps_longitude}`
        : "-"),
    issuesCount: issueCount,
    status: classificationStatus,
    raw: item,
    punchIds: (item.punches || []).map((p) => p.id),
  };
});

        // Save all rows
        setAllRows(formatted);

        // Reset page to 1 whenever data reloads
        setPage(1);
      }
    } catch (err) {
      console.error("Error fetching monthly attendance", err);
    } finally {
      setLoading(false);
    }
  };

  if (token) fetchData();
}, [token, selectedMonth, searchQuery, t]);


useEffect(() => {
  // sort first by date (descending)
  const sorted = [...allRows].sort(
    (a, b) => new Date(b.raw.date) - new Date(a.raw.date)
  );

  const startIdx = (page - 1) * 5;
  const endIdx = startIdx + 5;

  setRows(sorted.slice(startIdx, endIdx));
  setTotalPages(Math.ceil(sorted.length / 5) || 1);
}, [allRows, page]);

  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => setAnchorEl(null);

  const handleViewClick = () => {
    console.log("Selected punch IDs:", selectedRow?.punchIds);
    setDrawerOpen(true);
    handleMenuClose();
  };

  const HaederStyles = {
    color: "#44546F",
    fontSize: "14px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: 600,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };
  const DataStyles = {
    color: "#172B4D",
    fontSize: "12px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: 400,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };

  // utils/fetchAllMonthlySummary.js (or inside MonthlySummary.jsx)

const fetchAllMonthlySummary = async (token, selectedMonth, searchQuery) => {
  try {
    const monthParam = selectedMonth.format("YYYY-MM");

    const res = await fetch(
      `${BASE_URL}/attendance/monthly?month=${monthParam}&search=${searchQuery}&no_pagination=true`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    const json = await res.json();

    if (json.error) {
      console.error("❌ Failed to fetch monthly summary:", json.message);
      return [];
    }

    return (json.data?.records || []).map((item, idx) => {
      const issueCount = Number(
        item?.total_punch_issue_count ?? item?.issues?.total_punch_issue_count ?? 0
      );
      const classificationStatus =
        getDayClassificationStatus(item) || normalizeStatus(item.status);
      return {
        id: idx + 1,
        date: new Date(item.date).toLocaleString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        }),
        checkIn: item.first_check_in || "-",
        checkOut: item.last_check_out || "-",
        location:
          item.punches?.[0]?.location?.location_text ||
          (item.punches?.[0]?.location?.gps_latitude && item.punches?.[0]?.location?.gps_longitude
            ? `${item.punches[0].location.gps_latitude}, ${item.punches[0].location.gps_longitude}`
            : "-"),
        issuesCount: issueCount,
        status: classificationStatus,
        punchIds: (item.punches || []).map((p) => p.id),
      };
    });
  } catch (err) {
    console.error("❌ Error fetching all monthly summary:", err);
    return [];
  }
};

  const handleIcon = () => {
    navigate("/monthly-summary", { state: { fromDashboard: true } });
}
  return (
        <>
                   {fromDashboard && (
      <Box
        sx={{
          border: '1px solid #E4E6EF',
          borderRadius: 2,
          px: 2,
          backgroundColor: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          minHeight: 55,
          mb: 2,
          ml:1, mr:1
        }}
      >
        <Box
          sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }}
          onClick={() => navigate(-1)}
        >
          <img src={back} style={{ width: 30, height: 30 }} />
          <CustomText
            sx={{
              ...textStyles.h1,
              fontWeight: 500,
              fontSize: '14px',
              color: '#626F86',
              textAlign: 'center'
            }}
          >
            {t('worker')} 
          </CustomText>
        </Box>
      </Box>
    )}
    <Box
      sx={{
        p: 2,
        backgroundColor: "white",
        borderRadius: 2,
        border: "1px solid #E4E6EF",
        ml:1,mr:1,
      }}
    >
      {/* Header */}
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Typography sx={{ fontWeight: 600, fontSize: 16, fontFamily: "Poppins, sans-serif" }}>
          {t("monthlySummary.title")}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {/* Search */}
     

          {/* Month Select */}
       <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DatePicker
    views={["year", "month"]}
    value={selectedMonth}
    onChange={(newValue) => {
      setSelectedMonth(newValue);
      setPage(1); // reset to page 1 when month changes
    }}
  enableAccessibleFieldDOMStructure={false}
    maxDate={dayjs()} 
  slotProps={{
    textField: {
      size: "small",
      sx: {
        "& .MuiInputBase-root": {
          height: 34,
          fontSize: "14px",
        },
        "& .MuiInputBase-input": {
          padding: "2px 6px",
          fontSize: "14px",
        },
        "& .MuiSvgIcon-root": {
          fontSize: "16px",
        },
      },
    },
    popper: {
      sx: {
        "& .MuiPickersCalendarHeader-label": {
          fontSize: "14px", // shrink Month-Year label
          fontWeight: 500,
        },
        "& .MuiPickersCalendarHeader-switchViewButton": {
          fontSize: "12px", // shrink dropdown button
        },
        "& .MuiPickersArrowSwitcher-button": {
          fontSize: "12px", // shrink arrow buttons
        },
        "& .MuiDayCalendar-weekDayLabel": {
          fontSize: "14px", // week day letters (S M T W T F S)
        },
        "& .MuiPickersDay-root": {
          fontSize: "14px", // dates inside the grid
          width: 28,        // shrink day cell width
          height: 28,       // shrink day cell height
          margin: 1,
        },
      },
    },
  }}
  />
</LocalizationProvider>
           <IconButton>
                    <img
                      src={mapicon}
                      onClick={handleIcon}
                      alt="map"
                      style={{ width: 33, height: 33 }}
                    />
                  </IconButton>
        </Box>
      </Box>

      {/* Table */}
      <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={HaederStyles}>{t("monthlySummary.columns.id")}</TableCell>
              <TableCell sx={HaederStyles}>{t("monthlySummary.columns.date")}</TableCell>
              <TableCell sx={HaederStyles}>{t("checkIn")}</TableCell>
              <TableCell sx={HaederStyles}>{t("startBreak")}</TableCell>
              <TableCell sx={HaederStyles}>{t("endBreak")}</TableCell>
              <TableCell sx={HaederStyles}>{t("checkOut")}</TableCell>
              <TableCell sx={HaederStyles}>{t("monthlySummary.columns.location")}</TableCell>
              <TableCell sx={HaederStyles}>{t("monthlySummary.columns.issues")}</TableCell>
              <TableCell sx={HaederStyles}>{t("monthlySummary.columns.status")}</TableCell>
              <TableCell sx={HaederStyles}>{t("monthlySummary.columns.action")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={10} align="center">
                  <CircularProgress size={22} />
                </TableCell>
              </TableRow>
            ) : rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={10}>
                  <Box
                    sx={{ display: "flex", flexDirection: "column", alignItems: "center", height: 300 }}
                  >
                    <img src={emptyscreen} alt="No Data" style={{ width: 200 }} />
                    <CustomText sx={{ ...textStyles.h1, fontSize: "16px", color: "#003149", pt: 1 }}>
                      {t("empty.no_user")}
                    </CustomText>
                  </Box>
                </TableCell>
              </TableRow>
            ) : (
              rows.map((row, index) => (
                <TableRow key={index} hover>
                  <TableCell sx={DataStyles}>{row.id}</TableCell>
                  <TableCell sx={DataStyles}>{row.date}</TableCell>
                  <TableCell sx={{ ...DataStyles, whiteSpace: "pre-line", lineHeight: 1.5 }}>
                    {row.checkIn}
                  </TableCell>
                  <TableCell sx={{ ...DataStyles, whiteSpace: "pre-line", lineHeight: 1.5 }}>
                    {row.startBreak}
                  </TableCell>
                  <TableCell sx={{ ...DataStyles, whiteSpace: "pre-line", lineHeight: 1.5 }}>
                    {row.endBreak}
                  </TableCell>
                  <TableCell sx={{ ...DataStyles, whiteSpace: "pre-line", lineHeight: 1.5 }}>
                    {row.checkOut}
                  </TableCell>
                  <TableCell sx={DataStyles}>
                    <TruncatedCell text={row.location} />
                  </TableCell>
                  <TableCell sx={DataStyles}>{row.issuesCount ?? 0}</TableCell>
                  <TableCell sx={{ minWidth: 140 }}>
                    {row.status ? (
                      <Box sx={{ pointerEvents: "none", display: "inline-flex" }}>
                        <StatusDropdown currentStatus={row.status} />
                      </Box>
                    ) : (
                      "--"
                    )}
                  </TableCell>
                  <TableCell>
                    <IconButton onClick={(e) => handleMenuOpen(e, row)}>
                      <MoreVertIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
        <Pagination
           count={totalPages}
  page={page}
  onChange={(e, value) => setPage(value)}
          shape="rounded"
          color="primary"
          size="small"
        />
      </Box>

      {/* Menu */}
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
        <MenuItem onClick={handleViewClick} sx={{ fontSize: "12px" }}>
          {t("monthlySummary.menu.view")}
        </MenuItem>
      </Menu>

      {/* Drawer */}
      <AttendanceDetailsDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        selectedRow={selectedRow}
        monthlyApiData={monthlyApiData}
      />
    </Box>
    </>
  );
};

export default DashboardPunches;





